document.addEventListener("DOMContentLoaded", function() {
  'use strict';

  var html = document.querySelector('html'),
    menuOpenIcon = document.querySelector(".icon__menu"),
    menuCloseIcon = document.querySelector(".nav__icon-close"),
    menuList = document.querySelector(".main-nav"),
    searchOpenIcon = document.querySelector(".icon__search"),
    toggleTheme = document.querySelector(".toggle-theme"),
    btnScrollToTop = document.querySelector(".top");

  /* Menu */
  if (menuOpenIcon) {
    menuOpenIcon.addEventListener("click", function() {
      menuList.classList.add("is-open");
    });
  }

  if (menuCloseIcon) {
    menuCloseIcon.addEventListener("click", function() {
      menuList.classList.remove("is-open");
    });
  }

  /* Search - trigger Lunr plugin search */
  if (searchOpenIcon) {
    searchOpenIcon.addEventListener("click", function() {
      var lunrBtn = document.querySelector(".roq-search-btn");
      if (lunrBtn) {
        lunrBtn.click();
      }
    });
  }

  /* Theme Switcher */
  if (toggleTheme) {
    toggleTheme.addEventListener("click", function() {
      if (html.classList.contains('dark-mode')) {
        html.classList.remove('dark-mode');
        localStorage.removeItem("theme");
        document.documentElement.removeAttribute("dark");
      } else {
        html.classList.add('dark-mode');
        localStorage.setItem("theme", "dark");
        document.documentElement.setAttribute("dark", "");
      }
    });
  }

  /* Responsive Videos */
  if (typeof reframe === 'function') {
    reframe(".post__content iframe:not(.reframe-off), .page__content iframe:not(.reframe-off)");
  }

  /* Zoom Image */
  if (typeof Lightense === 'function') {
    var lightense = document.querySelector(".page__content img, .post__content img, .gallery__image img");
    var imageLink = document.querySelectorAll(".page__content a img, .post__content a img, .gallery__image a img");

    if (imageLink) {
      for (var i = 0; i < imageLink.length; i++) imageLink[i].parentNode.classList.add("image-link");
      for (var i = 0; i < imageLink.length; i++) imageLink[i].classList.add("no-lightense");
    }

    if (lightense) {
      // Lightense only creates its backdrop (and wires its internal container) when one
      // doesn't already exist. If init runs again (e.g. dev live-reload) the stale backdrop
      // makes it skip that step, leaving the container undefined and clicks throwing. Remove
      // any existing backdrop first so each init rebinds correctly.
      var staleBackdrop = document.querySelector(".lightense-backdrop");
      if (staleBackdrop) staleBackdrop.remove();
      Lightense(".page__content img:not(.no-lightense), .post__content img:not(.no-lightense), .gallery__image img:not(.no-lightense)", {
        padding: 60,
        offset: 30
      });
    }
  }

  /* Smooth scroll to tags page */
  document.querySelectorAll(".tag__link, .top__link").forEach(function(anchor) {
    anchor.addEventListener("click", function(e) {
      e.preventDefault();
      document.querySelector(this.getAttribute("href")).scrollIntoView({
        behavior: "smooth"
      });
    });
  });

  /* Scroll Top Button */
  if (btnScrollToTop) {
    btnScrollToTop.addEventListener("click", function() {
      if (window.scrollY != 0) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }
    });
  }

});
